document.getElementById('grcrst-location-id').addEventListener('change', function() {
  let selectElement = this;
  let selectedOption = selectElement.value;
  let currentLocation = localStorage.getItem('grcrst-selected-location');

  const titleCase = (s) => {
    return s.replace(/^[-_]*(.)/, (_, c) => c.toUpperCase())       // Initial char (after -/_)
     .replace(/[-_]+(.)/g, (_, c) => ' ' + c.toUpperCase()); // First char after each -/_
  }


  if (selectedOption && currentLocation != selectedOption) {
    selectElement.setAttribute('disabled', '');
    document.querySelector('.grcrst-location-selector-modal__content .loading__spinner').classList.remove('hidden');
    updateCart(selectedOption)
    .then(function(updateCartData) {
      localStorage.setItem('grcrst-selected-location', selectedOption);
      document.getElementById('grcrst-location-selector-msg').innerHTML = titleCase(selectedOption);
      return cleanCart();
    })
    .then(function(cleanCartData) {
      selectElement.removeAttribute('disabled');
      document.querySelector('.grcrst-location-selector-modal__content .loading__spinner').classList.add('hidden');
      window.location = `/?grcrst_switch=${selectedOption}`;
    })
    .catch(function() {
      console.error('Unable to empty the cart and update location.');
    });  
  } 
});

document.addEventListener('DOMContentLoaded', function () {
  const titleCase = (s) => {
    return s.replace(/^[-_]*(.)/, (_, c) => c.toUpperCase())       // Initial char (after -/_)
     .replace(/[-_]+(.)/g, (_, c) => ' ' + c.toUpperCase()); // First char after each -/_
  }

  let currentLocalStorageLocation = localStorage.getItem('grcrst-selected-location');
    getCart()
    .then(cartData => {
        const selectedLocation = cartData.attributes.selected_location;
        if (selectedLocation) {
            localStorage.setItem('grcrst-selected-location', selectedLocation);
            document.getElementById('grcrst-location-selector-msg').innerHTML = titleCase(selectedLocation);  
        } else {
          if (currentLocalStorageLocation) {
            updateCart(currentLocalStorageLocation)
            .then(cartData => {
              document.getElementById('grcrst-location-selector-msg').innerHTML = titleCase(currentLocalStorageLocation);
              document.getElementById('grcrst-location-id').value = currentLocalStorageLocation;
              document.getElementById('grcrst-location-selector-modal').removeAttribute('data-disable-close');
              document.getElementById('grcrst-location-selector-modal').hide();
            });
          }
        }
    })
    .catch(error => {
        console.error('Error getting cart data', error);
    });  
});

